import dynamic from 'next/dynamic';

export const PopupToDrawer = dynamic(() => import('./PopupToDrawer'), { ssr: false });
